import { InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';

export type BulkActionsSelectState = 'checked' | 'indeterminate' | 'unchecked';

export interface BulkActionsBatchSelectState {
  selectState: BulkActionsSelectState;
  selectedCount: number;
}

export interface BulkActionsBatchSelectStrategy {
  state$: Observable<BulkActionsBatchSelectState>;
  toggle: (selectAll: boolean) => void;
  stageState$?: (stageId: number) => Observable<BulkActionsSelectState>;
  toggleStage?: (stageId: number, selectAll: boolean) => void;
}

export const BULK_ACTIONS_BATCH_SELECT_STRATEGY =
  new InjectionToken<BulkActionsBatchSelectStrategy>('BULK_ACTIONS_BATCH_SELECT_STRATEGY');
